export default __webpack_public_path__ + "static/media/kimiya-logo-full.2bf6ec34.svg";